import axios from 'axios';

const BASE = import.meta.env.VITE_API_URL || 'https://apex-corporateweb-470928162af3.herokuapp.com';

const api = axios.create({ baseURL: BASE });

api.interceptors.response.use(
  response => response,
  error => {
    console.error('API Error:', error.config?.url, error.response?.status, error.message);
    return Promise.reject(error);
  }
);

export const getSiteConfig = () =>
  api.get('/api/site-config').then((r) => r.data.data);

export const getBrands = () =>
  api.get('/api/brands').then((r) => r.data.data);

export const getSubsidiaries = () =>
  api.get('/api/subsidiaries').then((r) => r.data.data);

export const getNewsletters = (params?: { page?: number; limit?: number; type?: string; customType?: string; featured?: boolean }) =>
  api.get('/api/newsletters', { params }).then((r) => r.data);

export const getNewsletter = (slug: string) =>
  api.get(`/api/newsletters/${slug}`).then((r) => r.data.data);

export const getNewsletterTypes = () =>
  api.get('/api/newsletters/types').then((r) => r.data.data as Array<{ _id: string; customType?: string; count: number }>);

export const subscribe = (email: string, name?: string) =>
  api.post('/api/subscribers/subscribe', { email, name }).then((r) => r.data);

export const getTeam = () =>
  api.get('/api/team').then((r) => r.data.data);

export const getFeaturedTeam = () =>
  api.get('/api/team/featured').then((r) => r.data.data);

export const submitContact = (data: {
  name: string;
  email: string;
  phone?: string;
  company?: string;
  message: string;
  inquiryType?: string;
  source?: 'contact' | 'investor';
}) => api.post('/api/contact', data).then((r) => r.data);
